import { RowNode } from 'ag-grid-community';
import { AgGridColumn } from 'ag-grid-react/lib/agGridColumn';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ConnectedHcpGridWithGQL, LocationSearch } from '.';
import { useOrganizationAddressInfoQuery } from '../graphql';
import { AnyType } from '../interfaces';
import { AppRootState, navigateToLocationsNew } from '../redux';
import { featureGridColumnsSelector, getFeatureGridColumnProps, isEmptyObject, rawHtmlProps } from '../utils';
import { FeatureGuard } from './multi-tenant/FeatureGuard';

const columnSelector = featureGridColumnsSelector('locations.table');

export const LocationsTable = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState<string>();
  const verbiageText = useSelector(
    (state: AppRootState) =>
      (((state.app?.entities?.features as AnyType) ?? {})['account-administration-verbiage'] as AnyType)?.data || {}
  );

  const filterLocations = (node: RowNode, value: string | undefined) => {
    const { address1, city, state } = node.data;
    return (
      address1?.toLowerCase().includes(value ?? '') ||
      city?.toLowerCase().includes(value ?? '') ||
      state?.toLowerCase().includes(value ?? '')
    );
  };

  const columns = useSelector(columnSelector);

  if (!columns) return null;

  return (
    <>
      <div className='d-flex justify-content-between mb-3'>
        <div className='w-25'>
          <LocationSearch onSearch={setSearchValue} />
        </div>
        <FeatureGuard contentKey={'practice-management.locations.manage'}>
          <Button
            variant='secondary'
            data-testid='navigateToAddLocationBtn'
            onClick={() => dispatch(navigateToLocationsNew())}>
            ADD A LOCATION
          </Button>
        </FeatureGuard>
      </div>
      <ConnectedHcpGridWithGQL
        queryHook={useOrganizationAddressInfoQuery}
        isFilterActive={!!searchValue}
        filterComparator={filterLocations}
        filterValue={searchValue}
        pagination>
        <AgGridColumn field='address1' {...getFeatureGridColumnProps(columns.address)} />
        <AgGridColumn field='city' {...getFeatureGridColumnProps(columns.city)} />
        <AgGridColumn field='state' {...getFeatureGridColumnProps(columns.state)} />
        <AgGridColumn field='zip' {...getFeatureGridColumnProps(columns.zip)} />
        <AgGridColumn field='phone1' {...getFeatureGridColumnProps(columns.phone)} />
      </ConnectedHcpGridWithGQL>
      {!isEmptyObject(verbiageText) && (
        <span className='text-primary ag-theme-alpine' {...rawHtmlProps(verbiageText)} />
      )}
    </>
  );
};
